// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + "main" + "-" + "af4202593ec3072535c6" + ".css";
};